/** Workflows (M29, BOT-005): saved test cases, three runs and the publish gate. Merged into `engage.workflows.regression`. */
export const workflowsRegression = {
  tab: "Tests",
  title: "Test cases",
  intro: "Save the conversations this flow must handle. Run them three times: a flow with test cases is published only after the last run passed.",
  add: "Add test case",
  run: "Run 3 times",
  running: "Running…",
  runStarted: "The cases are running.",
  saved: "Test case saved.",
  deleted: "Test case deleted.",
  limit: "{{count}} test cases is the most a workflow keeps. Delete one to add another.",
  empty: {
    title: "No test cases yet",
    body: "Describe what a customer writes and what the flow must do. The cases run three times before the flow can be published.",
  },
  loadFailed: "The test cases could not be loaded.",
  list: {
    messages_one: "{{count}} customer message",
    messages_other: "{{count}} customer messages",
    customer: "Customer: {{details}}",
    path: "Reaches {{path}}",
    handoverYes: "Hands over to a person",
    handoverNo: "Does not hand over",
    contains: "Replies with: {{words}}",
    edit: "Edit {{name}}",
    delete: "Delete {{name}}",
    deleteTitle: "Delete this test case?",
    deleteBody: "“{{name}}” is removed. The next run no longer checks it.",
    confirmDelete: "Delete test case",
  },
  form: {
    addTitle: "Add a test case",
    editTitle: "Edit test case",
    description: "The first message starts the flow; the next ones answer what it asks (a button by its label, or a value).",
    name: "Name",
    messages: "Customer messages (one per line)",
    messagesHint: "The first line must match the words that start this flow.",
    tier: "Customer tier",
    status: "Account status",
    attributes: "Other customer details (key=value, one per line)",
    attributesHint: "For example kyc_status=pending. Keys use lowercase letters, digits and underscores.",
    path: "Must reach this path",
    pathHint: "A path letter (B) or its name.",
    handover: "Hands over to a person",
    handoverAny: "Not checked",
    handoverYes: "Yes",
    handoverNo: "No",
    contains: "The flow's replies must contain (one per line)",
    save: "Save test case",
    cancel: "Cancel",
    problems: {
      name: "Give the test case a name.",
      messages: "Write at least one customer message.",
      attributes: "Write each detail as key=value with a lowercase key.",
      expected: "Check at least one thing: a path, a handover or words in the replies.",
    },
  },
  run_state: {
    never: "Not run yet",
    running: "Running the cases…",
    passed: "Passed all {{count}} runs",
    failed: "Failed",
    stale: "Passed, but the draft or the cases changed since. Run them again.",
    error: "The run did not finish. Run it again.",
  },
  results: {
    title: "Last run",
    case: "Test case",
    outcome: "Result",
    passed: "{{passed}} of {{total}} runs passed",
    runPassed: "Run {{n}} passed",
    runFailed: "Run {{n}} failed",
    failure: {
      not_started: "The flow did not start on the first message",
      path_not_reached: "The path was not reached",
      handover_mismatch: "The handover was not as expected",
      answer_missing: "The replies did not contain the words",
      stuck: "The flow did not finish in time",
      error: "The flow could not be played",
    },
    removed: "A case that was deleted",
  },
  publish: {
    title: "Publishing is held by the test cases",
    why: {
      no_run: "These test cases have not been run yet.",
      running: "The test cases are still running.",
      failed: "The last run of the test cases failed.",
      stale: "The draft or the test cases changed after the last run.",
    },
    body: "Run the test cases three times. When all of them pass, publish.",
    runAgain: "Run 3 times",
    publish: "Publish",
    published: "Published version {{version}}.",
    close: "Close",
    overrideTitle: "Publish anyway",
    overrideBody: "Needs the publish override permission. Your reason is kept in the audit log.",
    reason: "Reason",
    reasonHint: "Say why this version goes out without a passing run.",
    reasonMissing: "Write the reason first.",
    overrideConfirm: "Publish without a passing run",
    overridden: "Published with an override. It is recorded in the audit log.",
    noOverride: "Only a member with the publish override permission can publish without a passing run.",
  },
} as const;
